<div class="input" [ngClass]="{ 'input--active': value && label, 'input--error': error, 'input--disabled': disabled, 'input--with-icon': icon || type === 'date' }">
  <div class="input__wrap">
    <div class="input__inner">
      @if (label) {
        <label class="input__label" [for]="id">
          {{ label }}
          @if (required) {
            <span class="input__label-required">*</span>
          }
        </label>
      }
      <div class="input__inner">
        @if (type !== 'date') {
          <input
            class="input__main input__main--text-align-{{ textAlign }}"
            [ngClass]="{ 'input__main--after': after }"
            [id]="id"
            [attr.pattern]="pattern"
            [type]="type === 'password' ? (visiblePassword ? 'text' : type) : type"
            [attr.name]="name"
            [(ngModel)]="value"
            [required]="required"
            [placeholder]="placeholder"
            [disabled]="disabled"
            [autocomplete]="autocomplete"
            (change)="validate(true)"
            (keyup)="formatThousands()"
            (input)="validate()"
            (focusout)="focusOut()"
          />
        } @else {
          <input
            class="input__main input__main--text-align-{{ textAlign }}"
            [ngClass]="{ 'input__main--after': after }"
            readonly="readonly"
            [id]="id"
            [attr.pattern]="pattern"
            [type]="'text'"
            [attr.name]="name"
            [(ngModel)]="value"
            [required]="required"
            [placeholder]="placeholder"
            [disabled]="disabled"
            [autocomplete]="autocomplete"
            [matDatepicker]="picker"
            [min]="min ?? actualDate"
            (click)="picker.open()"
            (change)="validate(true)"
            (input)="validate()"
            (focusout)="focusOut()"
          />
          <mat-datepicker (closed)="validate()" #picker></mat-datepicker>
        }
        @if (icon || type === 'date') {
          <app-icon class="input__icon" [icon]="icon ?? 'calendar'" [width]="24"></app-icon>
        }
        @if (after) {
          <div class="input__after">{{ after }}</div>
        }
        @if (type === 'password') {
          <button class="input__password" [ngClass]="{ 'input__password--active': visiblePassword }" type="button" (click)="togglePassword()">
            <app-icon [icon]="'eye'" [width]="20"></app-icon>
          </button>
        }
        @if (tooltip) {
          <span class="input__tooltip" [app-tooltip]="tooltip">
            <app-icon [icon]="'info'" [width]="20"></app-icon>
          </span>
        }
      </div>
    </div>
  </div>
  @if (error) {
    <div class="input__info">
      <app-input-error class="input__error">
        {{ errorMessage }}
      </app-input-error>
    </div>
  }
</div>
